import { render, staticRenderFns } from "./ProductCategories.vue?vue&type=template&id=38b810b7&"
import script from "./ProductCategories.vue?vue&type=script&lang=ts&"
export * from "./ProductCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports